export const getPathLabTestDataJson = () => {
  return {
    sampleId: "",
    sampleType: "",
    sampleCollectionDateTime: "",
    sampleCollectionLocation: "",
    sampleCollectionMethod: "",
    sampleCollectionPerformedBy: "",
    sampleCollectionReportDate: "",
    sampleCollectionNotes: "",
    additionalNotes: "",

    tests: [
      {
        testId: "LT12345",
        testName: "Hematology",
        referenceText:
          "<p>Complete Blood Count (CBC) is a comprehensive screening test used to check for a variety of disorders including anemia, infection and leukemia.</p><ul><li><b>Red Blood Cells (RBC):</b> Carry oxygen from lungs to tissues</li><li><b>White Blood Cells (WBC):</b> Fight infections and diseases</li><li><b>Platelets:</b> Help blood clot to stop bleeding</li><li><b>Hemoglobin:</b> Protein in RBCs that carries oxygen</li></ul><p>Preparation: No special preparation required. <b>Fasting is not necessary.</b></p>",
        parameters: [
          {
            selected: false,
            parameterId: "P123",
            parameterName: "Hemoglobin",
            resultValue: "",
            unit: "g/dL",
            lowerLimit: "13.0",
            upperLimit: "17.0",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "P124",
            parameterName: "White Blood Cell Count",
            resultValue: "",
            unit: "10^9/L",
            lowerLimit: "4.0",
            upperLimit: "11.0",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "P125",
            parameterName: "Platelet Count",
            resultValue: "",
            unit: "10^9/L",
            lowerLimit: "150",
            upperLimit: "450",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "P126",
            parameterName: "Red Blood Cell Count",
            resultValue: "",
            unit: "10^12/L",
            lowerLimit: "4.5",
            upperLimit: "6.0",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "P127",
            parameterName: "ESR ",
            resultValue: "",
            unit: "mm/hr",
            lowerLimit: "0",
            upperLimit: "20",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "P128",
            parameterName: "Hematocrit",
            resultValue: "",
            unit: "%",
            lowerLimit: "37",
            upperLimit: "52",
            status: "Normal",
            notes: "",
          },
        ],
      },
      {
        testId: "LT67890",
        testName: "Biochemistry",
        referenceText:
          "<p>Biochemistry - Biochemical tests help in assessing metabolic and systemic functions of the body, including kidney, liver, lipid, and electrolyte balance.</p><p><b>Clinical Significance:</b></p><p><b>Blood Glucose:</b> Used to diagnose and monitor diabetes mellitus and hypoglycemia.</p><p><b>Liver Function Tests (LFT):</b> Abnormal bilirubin, AST, ALT, and ALP indicate liver damage, hepatitis, biliary obstruction, or alcohol-related disorders.</p><p><b>Kidney Function Tests (KFT):</b> Elevated urea and creatinine reflect impaired renal function, dehydration, or obstruction.</p><p><b>Lipid Profile:</b> Elevated cholesterol and triglycerides are risk factors for cardiovascular disease and metabolic syndrome.</p><p><b>Electrolytes:</b> Imbalances in sodium, potassium, chloride, and bicarbonate are linked with dehydration, kidney disorders, and acid–base imbalance.</p><p><b>Proteins:</b> Albumin and total protein levels indicate nutritional status, liver disease, or nephrotic syndrome.</p>",

        parameters: [
          {
            selected: false,
            parameterId: "B101",
            parameterName: "Glucose (Fasting)",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "70",
            upperLimit: "99",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "B102",
            parameterName: "Glucose (Random)",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "70",
            upperLimit: "140",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "B102",
            parameterName: "Blood Urea",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "17",
            upperLimit: "43",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "B103",
            parameterName: "Serum Creatinine",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "0.6",
            upperLimit: "1.3",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "B104",
            parameterName: "Total Bilirubin",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "0.2",
            upperLimit: "1.2",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "B105",
            parameterName: "SGOT (AST)",
            resultValue: "",
            unit: "U/L",
            lowerLimit: "5",
            upperLimit: "40",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "B106",
            parameterName: "SGPT (ALT)",
            resultValue: "",
            unit: "U/L",
            lowerLimit: "7",
            upperLimit: "56",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "B107",
            parameterName: "Alkaline Phosphatase",
            resultValue: "",
            unit: "U/L",
            lowerLimit: "44",
            upperLimit: "147",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "B108",
            parameterName: "Total Protein",
            resultValue: "",
            unit: "g/dL",
            lowerLimit: "6.0",
            upperLimit: "8.3",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "B109",
            parameterName: "Albumin",
            resultValue: "",
            unit: "g/dL",
            lowerLimit: "3.5",
            upperLimit: "5.0",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "B110",
            parameterName: "Calcium",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "8.6",
            upperLimit: "10.2",
            status: "Normal",
            notes: "",
          },
        ],
      },
      {
        testId: "LT98765",
        testName: "Immunology",
        referenceText:
          "<p>Immunology - Immunological tests detect immune responses, autoimmune disorders, allergies, and infectious diseases.</p><p><b>Clinical Significance:</b></p><p><b>CRP (C-Reactive Protein):</b> Elevated in acute infections, inflammation, and cardiovascular risk assessment.</p><p><b>Rheumatoid Factor (RF) & Anti-CCP:</b> Markers for rheumatoid arthritis and autoimmune disorders.</p><p><b>ANA (Antinuclear Antibody):</b> Positive in systemic lupus erythematosus and connective tissue diseases.</p><p><b>Allergy Testing (IgE):</b> Increased IgE levels indicate allergic conditions like asthma and eczema.</p><p><b>HIV, HBsAg, HCV Antibodies:</b> Used for screening and diagnosis of viral infections.</p><p><b>Immunoglobulins (IgG, IgA, IgM):</b> Abnormal levels suggest immune deficiency, chronic infection, or autoimmune disease.</p>",

        parameters: [
          {
            selected: false,
            parameterId: "I201",
            parameterName: "C-Reactive Protein (CRP)",
            resultValue: "",
            unit: "mg/L",
            lowerLimit: "0",
            upperLimit: "5",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "I202",
            parameterName: "Rheumatoid Factor (RF)",
            resultValue: "",
            unit: "IU/mL",
            lowerLimit: "0",
            upperLimit: "14",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "I203",
            parameterName: "Anti-Nuclear Antibody (ANA)",
            resultValue: "",
            unit: "",
            lowerLimit: "",
            upperLimit: "",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "I204",
            parameterName: "HIV 1 & 2 Antibodies",
            resultValue: "",
            unit: "",
            lowerLimit: "",
            upperLimit: "",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "I205",
            parameterName: "Hepatitis B Surface Antigen (HBsAg)",
            resultValue: "",
            unit: "",
            lowerLimit: "",
            upperLimit: "",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "I206",
            parameterName: "Hepatitis C Antibodies (Anti-HCV)",
            resultValue: "",
            unit: "",
            lowerLimit: "",
            upperLimit: "",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "I207",
            parameterName: "IgE Total",
            resultValue: "",
            unit: "IU/mL",
            lowerLimit: "0",
            upperLimit: "100",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "I208",
            parameterName: "COVID-19 IgG Antibody",
            resultValue: "",
            unit: "",
            lowerLimit: "",
            upperLimit: "",
            status: "Abnormal",
            notes: "",
          },
        ],
      },
      {
        testId: "LT54321",
        testName: "Microbiology",
        referenceText:
          "<p>Microbiology - Microbiological tests help in detection, identification, and antimicrobial susceptibility of pathogenic organisms causing infections.</p><p><b>Clinical Significance:</b></p><p><b>Culture & Sensitivity:</b> Identifies bacteria or fungi in samples (urine, blood, sputum, pus) and determines effective antibiotics.</p><p><b>Blood Culture:</b> Detects septicemia and guides treatment of systemic infections.</p><p><b>Urine Culture:</b> Used to diagnose urinary tract infections and select appropriate therapy.</p><p><b>Sputum Culture:</b> Helps in diagnosing respiratory tract infections like pneumonia and tuberculosis.</p><p><b>Stool Culture:</b> Detects enteric pathogens such as Salmonella, Shigella, and E. coli in diarrheal diseases.</p><p><b>Microscopy & Staining (Gram, AFB, KOH):</b> Rapid identification of bacteria, mycobacteria, and fungi.</p><p><b>Serological Tests:</b> Detect microbial antigens or antibodies in infections like typhoid, dengue, syphilis, and malaria.</p>",
        parameters: [
          {
            selected: false,
            parameterId: "M301",
            parameterName: "Urine Culture & Sensitivity",
            resultValue: "",
            unit: "",
            lowerLimit: "",
            upperLimit: "",
            status: "normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "M302",
            parameterName: "Blood Culture",
            resultValue: "",
            unit: "",
            lowerLimit: "",
            upperLimit: "",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "M303",
            parameterName: "Sputum Culture",
            resultValue: "",
            unit: "",
            lowerLimit: "",
            upperLimit: "",
            status: "normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "M304",
            parameterName: "Stool Culture",
            resultValue: "",
            unit: "",
            lowerLimit: "",
            upperLimit: "",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "M305",
            parameterName: "AFB Smear (Ziehl-Neelsen stain)",
            resultValue: "",
            unit: "",
            lowerLimit: "",
            upperLimit: "",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "M306",
            parameterName: "Malaria Parasite (MP) Smear",
            resultValue: "",
            unit: "",
            lowerLimit: "",
            upperLimit: "",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "M307",
            parameterName: "Widal Test - TO Titre",
            resultValue: "",
            unit: "",
            lowerLimit: "<1:80",
            upperLimit: "",
            status: "Borderline",
            notes: "",
          },
          {
            selected: false,
            parameterId: "M308",
            parameterName: "Widal Test - TH Titre",
            resultValue: "",
            unit: "",
            lowerLimit: "<1:80",
            upperLimit: "",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "M309",
            parameterName: "HIV 1 RNA PCR",
            resultValue: "",
            unit: "copies/mL",
            lowerLimit: "0",
            upperLimit: "",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "M310",
            parameterName: "HBV DNA Quantitative PCR",
            resultValue: "",
            unit: "IU/mL",
            lowerLimit: "0",
            upperLimit: "20",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "M311",
            parameterName: "HCV RNA PCR",
            resultValue: "",
            unit: "IU/mL",
            lowerLimit: "0",
            upperLimit: "",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "M312",
            parameterName: "Throat Swab Culture",
            resultValue: "",
            unit: "",
            lowerLimit: "",
            upperLimit: "",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "M313",
            parameterName: "Pus Culture",
            resultValue: "",
            unit: "",
            lowerLimit: "",
            upperLimit: "",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "M314",
            parameterName: "Gram Stain - Urine",
            resultValue: "",
            unit: "",
            lowerLimit: "",
            upperLimit: "",
            status: "Normal",
            notes: "",
          },
        ],
      },
      {
        testId: "LT99902",
        testName: "Liver Function Test (LFT)",
        referenceText:
          "<p>Liver Function Test (LFT) is a comprehensive panel used to assess liver health and function by measuring various enzymes, proteins, and substances produced or processed by the liver. The liver filters blood, metabolizes nutrients, detoxifies harmful substances, and produces blood clotting proteins.</p><ul><li><b>AST (SGOT):</b> Aspartate aminotransferase enzyme found in liver and muscle tissues</li><li><b>ALT (SGPT):</b> Alanine aminotransferase enzyme primarily found in liver cells</li><li><b>Alkaline Phosphatase (ALP):</b> Enzyme linked to bile production and flow from liver</li><li><b>Gamma-Glutamyl Transferase (GGT):</b> Enzyme associated with bile duct function</li><li><b>Total Protein:</b> Sum of all proteins in blood, mainly albumin and globulins</li><li><b>Albumin:</b> Major protein produced by liver, maintains fluid balance</li><li><b>Total Bilirubin:</b> Waste product from red blood cell breakdown, processed by liver</li></ul><p>Preparation: <b>Fasting for 8-12 hours is recommended</b> for accurate results. Avoid alcohol for 24 hours before testing.</p><p><b>Clinical Significance:</b> Liver cells contain enzymes that facilitate liver functions. When liver cells are damaged, these enzymes leak into the blood and become detectable through blood tests, indicating liver injury or dysfunction.</p><p><b>Interpretation Guidelines:</b></p><p><b>Liver Enzymes:</b></p><ul><li><b>AST (SGOT):</b> May indicate tissue injury or damage in muscles or liver. Elevated levels suggest cellular damage</li><li><b>ALT (SGPT):</b> Primarily found in the liver. Elevated ALT along with AST suggests liver damage or hepatocellular injury</li><li><b>Alkaline Phosphatase & GGT:</b> Linked to bile production and flow. Elevated levels may indicate bile flow issues (cholestasis) related to the liver, gallbladder, or bile ducts</li></ul><p><b>Blood Proteins:</b> Albumin and globulin are essential for growth, development, and health.</p><ul><li><b>Low Total Protein:</b> May indicate bleeding, liver disorders, malnutrition, or agammaglobulinemia</li><li><b>High Total Protein (Hyperproteinemia):</b> Often due to dehydration or increased protein production</li><li><b>Low Albumin:</b> Caused by poor diet, kidney disease, or liver disease</li><li><b>High Albumin:</b> Usually due to severe dehydration</li></ul><p><b>Bilirubin Interpretation:</b></p><ul><li><b>Elevated Total Bilirubin:</b> May indicate liver dysfunction, bile duct obstruction, or increased red blood cell breakdown</li><li><b>Direct vs Indirect Bilirubin:</b> Helps differentiate between hepatic (liver) and pre-hepatic (hemolytic) causes</li></ul><p><b>Common Clinical Patterns:</b></p><table border='1' style='border-collapse:collapse; margin:10px 0;'><tr><th>Condition</th><th>AST/ALT</th><th>ALP/GGT</th><th>Bilirubin</th><th>Albumin</th></tr><tr><td>Hepatocellular Injury</td><td>Markedly Elevated</td><td>Normal/Mild ↑</td><td>Variable</td><td>May be Low</td></tr><tr><td>Cholestatic Disease</td><td>Normal/Mild ↑</td><td>Markedly Elevated</td><td>Elevated</td><td>Normal</td></tr><tr><td>Chronic Liver Disease</td><td>Mild-Moderate ↑</td><td>Variable</td><td>Elevated</td><td>Low</td></tr><tr><td>Acute Hepatitis</td><td>Very High</td><td>Mild ↑</td><td>High</td><td>Normal/Low</td></tr></table><p><b>Important Notes:</b> LFT results should be interpreted together as a panel. Single elevated values may not be clinically significant. Consider patient symptoms, medical history, and repeat testing for confirmation of abnormal results.</p>",

        parameters: [
          {
            selected: false,
            parameterId: "LFT101",
            parameterName: "Total Bilirubin",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "0.2",
            upperLimit: "1.2",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "LFT102",
            parameterName: "Direct Bilirubin",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "0.0",
            upperLimit: "0.3",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "LFT103",
            parameterName: "Indirect Bilirubin",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "0.1",
            upperLimit: "0.9",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "LFT104",
            parameterName: "SGOT (AST)",
            resultValue: "",
            unit: "U/L",
            lowerLimit: "5",
            upperLimit: "40",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "LFT105",
            parameterName: "SGPT (ALT)",
            resultValue: "",
            unit: "U/L",
            lowerLimit: "7",
            upperLimit: "56",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "LFT106",
            parameterName: "Alkaline Phosphatase (ALP)",
            resultValue: "",
            unit: "U/L",
            lowerLimit: "44",
            upperLimit: "147",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "LFT107",
            parameterName: "Total Protein",
            resultValue: "",
            unit: "g/dL",
            lowerLimit: "6.0",
            upperLimit: "8.3",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "LFT108",
            parameterName: "Albumin",
            resultValue: "",
            unit: "g/dL",
            lowerLimit: "3.5",
            upperLimit: "5.0",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "LFT109",
            parameterName: "Globulin",
            resultValue: "",
            unit: "g/dL",
            lowerLimit: "2.0",
            upperLimit: "3.5",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "LFT110",
            parameterName: "Albumin/Globulin Ratio",
            resultValue: "",
            unit: "",
            lowerLimit: "1.1",
            upperLimit: "2.5",
            status: "Normal",
            notes: "",
          },
        ],
      },
      {
        testId: "LT99903",
        testName: "Glucose Fasting",
        referenceText: "",
        parameters: [
          {
            selected: false,
            parameterId: "GF101",
            parameterName: "Glucose (Fasting)",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "70",
            upperLimit: "99",
            status: "Normal",
            notes: "",
          },
        ],
      },
      {
        testId: "LT99904",
        testName: "Kidney Function Test (KFT)",

        referenceText:
          "<p>Kidney Function Tests are a collective term for a variety of individual tests and procedures that can be done to evaluate how well the kidneys are functioning. Many conditions can affect the ability of the kidneys to carry out their vital functions. Some lead to a rapid (acute) decline in kidney function, others lead to a gradual (chronic) decline in function. Both result in a buildup of toxic waste substances. Tests are done on urine samples, as well as on blood samples.</p><p><b>Symptoms Indicating Kidney Problems:</b> A number of symptoms may indicate a problem with your kidneys. These include: high blood pressure, blood in urine, frequent urges to urinate, difficulty beginning urination, painful urination, swelling in the hands and feet due to a buildup of fluids in the body. A single symptom may not mean something serious. However, when occurring simultaneously, these symptoms suggest that your kidneys are not working properly. Kidney function tests can help determine the reason.</p><p><b>Electrolyte Balance:</b> Electrolytes are present in the human body and the balancing act of the electrolytes in our bodies is essential for normal function of our cells and organs. There has to be a balance.</p><p><b>Ionized Calcium:</b> This test if you have signs of kidney or parathyroid disease. The test may also be done to monitor progress and treatment of these diseases.</p><p><b>eGFR:</b> eGFR test is applicable for patients aged 18 years or more.</p>",

        parameters: [
          {
            selected: false,
            parameterId: "KFT101",
            parameterName: "Blood Urea",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "17",
            upperLimit: "43",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "KFT102",
            parameterName: "Serum Creatinine",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "0.6",
            upperLimit: "1.3",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "KFT103",
            parameterName: "Uric Acid",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "3.5",
            upperLimit: "7.2",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "KFT104",
            parameterName: "BUN (Blood Urea Nitrogen)",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "7",
            upperLimit: "20",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "KFT105",
            parameterName: "Sodium",
            resultValue: "",
            unit: "mmol/L",
            lowerLimit: "135",
            upperLimit: "145",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "KFT106",
            parameterName: "Potassium",
            resultValue: "",
            unit: "mmol/L",
            lowerLimit: "3.5",
            upperLimit: "5.1",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "KFT107",
            parameterName: "Chloride",
            resultValue: "",
            unit: "mmol/L",
            lowerLimit: "96",
            upperLimit: "106",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "KFT108",
            parameterName: "Calcium",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "8.6",
            upperLimit: "10.2",
            status: "Normal",
            notes: "",
          },
        ],
      },
      {
        testId: "LT99905",
        testName: "Lipid Profile",
        referenceText:
          "<p>Lipid Profile is a comprehensive screening test used to assess cardiovascular risk by measuring different types of cholesterol and fats in the blood. This test helps evaluate the risk of developing heart disease, stroke, and other cardiovascular conditions.</p><ul><li><b>Total Cholesterol:</b> Overall amount of cholesterol in blood, including both good and bad cholesterol</li><li><b>HDL Cholesterol (Good Cholesterol):</b> High-density lipoprotein that helps remove cholesterol from arteries</li><li><b>LDL Cholesterol (Bad Cholesterol):</b> Low-density lipoprotein that can build up in arteries and cause blockages</li><li><b>Triglycerides:</b> Type of fat in blood that stores unused calories and provides energy</li><li><b>VLDL Cholesterol:</b> Very low-density lipoprotein that carries triglycerides in the blood</li></ul><p>Preparation: <b>Fasting for 9-12 hours is required</b> for accurate triglyceride and LDL measurements. Only water is allowed during fasting period.</p><p><b>Clinical Significance:</b> Elevated cholesterol levels increase risk of atherosclerotic cardiovascular disease (ASCVD). Regular monitoring helps guide treatment decisions and lifestyle modifications.</p><p><b>Interpretation Guidelines:</b> Lipid level assessments must be made following 9 to 12 hours of fasting, otherwise assay results might lead to erroneous interpretation. NCEP recommends of 3 different samples to be drawn at intervals of 1 week for harmonizing biological variables that might be encountered in single assays.</p><table border='1' style='border-collapse:collapse; margin:10px 0;'><tr><th>Parameter</th><th>Optimal</th><th>Above Optimal</th><th>Borderline High</th><th>High</th><th>Very High</th></tr><tr><td>Total Cholesterol (mg/dL)</td><td>&lt;200</td><td>-</td><td>200-239</td><td>≥240</td><td>-</td></tr><tr><td>Triglycerides (mg/dL)</td><td>&lt;150</td><td>-</td><td>150-199</td><td>200-499</td><td>≥500</td></tr><tr><td>LDL Cholesterol (mg/dL)</td><td>&lt;100</td><td>100-129</td><td>130-159</td><td>160-189</td><td>≥190</td></tr><tr><td>Non HDL Cholesterol (mg/dL)</td><td>&lt;130</td><td>130-159</td><td>160-189</td><td>190-219</td><td>≥220</td></tr></table><p><b>HDL Cholesterol Levels:</b> Low: &lt;40 mg/dL, High: ≥60 mg/dL</p><p><b>Risk Stratification Categories:</b></p><ul><li><b>Extreme Risk Group Category A:</b> CAD with &gt;1 feature of high risk group</li><li><b>Extreme Risk Group Category B:</b> CAD with &gt;1 feature of very high risk group of recurrent ACS (within 1 year) despite LDL-C treatment</li><li><b>High Risk:</b> Age ≥45 years in Males &amp; ≥55 years in Females, Family history of premature ASCVD, Low HDL, CHD stage 3B or 4, LDL &gt;190 mg/dl, Extreme of single risk factor, CAC &gt;300 AU, Lipoprotein(a) ≥50 mg/dl, Non stenotic carotid plaque</li><li><b>Moderate Risk:</b> 2 major ASCVD risk factors</li><li><b>Low Risk:</b> 0-1 major ASCVD risk factors</li></ul><p><b>Treatment Goals by Risk Category:</b></p><table border='1' style='border-collapse:collapse; margin:10px 0;'><tr><th>Risk Group</th><th>LDL-C Goal (mg/dl)</th><th>Non-HDL Goal (mg/dl)</th><th>Consider Drug Therapy LDL-C (mg/dl)</th><th>Consider Drug Therapy Non-HDL (mg/dl)</th></tr><tr><td>Extreme Risk Category A</td><td>&lt;50 (Optional: ≤30)</td><td>&lt;80 (Optional: ≤60)</td><td>≥50 (≥30)</td><td>≥80 (≥60)</td></tr><tr><td>Extreme Risk Category B</td><td>&lt;50</td><td>&lt;80</td><td>≥50</td><td>≥80</td></tr><tr><td>Very High Risk</td><td>&lt;70</td><td>&lt;100</td><td>≥70</td><td>≥100</td></tr><tr><td>High Risk</td><td>&lt;100</td><td>&lt;130</td><td>≥100</td><td>≥130</td></tr><tr><td>Moderate Risk</td><td>&lt;100*</td><td>&lt;130*</td><td>≥130*</td><td>≥160*</td></tr><tr><td>Low Risk</td><td>-</td><td>-</td><td>-</td><td>-</td></tr></table><p><small>*After an adequate non-pharmacological intervention for at least 3 months</small></p><p><b>Reference:</b> Management of Dyslipidaemia for the Prevention of Stroke: Clinical practice Recommendations from the Lipid Association of India. Current Vascular Pharmacology, 2022, 20, 134-155</p>",
        parameters: [
          {
            selected: false,
            parameterId: "LP101",
            parameterName: "Total Cholesterol",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "125",
            upperLimit: "200",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "LP102",
            parameterName: "HDL Cholesterol",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "40",
            upperLimit: "60",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "LP103",
            parameterName: "LDL Cholesterol",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "0",
            upperLimit: "129",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "LP104",
            parameterName: "Triglycerides",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "0",
            upperLimit: "150",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "LP105",
            parameterName: "VLDL Cholesterol",
            resultValue: "",
            unit: "mg/dL",
            lowerLimit: "5",
            upperLimit: "40",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "LP106",
            parameterName: "Total Cholesterol/HDL Ratio",
            resultValue: "",
            unit: "",
            lowerLimit: "0",
            upperLimit: "5.0",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "LP107",
            parameterName: "LDL/HDL Ratio",
            resultValue: "",
            unit: "",
            lowerLimit: "0",
            upperLimit: "3.5",
            status: "Normal",
            notes: "",
          },
        ],
      },
      {
        testId: "LT99906",
        testName: "Iron Studies",
        referenceText:
          "<p>Iron Studies is a comprehensive panel used to evaluate iron metabolism and diagnose iron-related disorders including iron deficiency anemia, hemochromatosis, and chronic inflammatory conditions affecting iron status.</p><ul><li><b>Serum Iron:</b> Measures the amount of iron circulating in blood bound to transferrin</li><li><b>Total Iron Binding Capacity (TIBC):</b> Measures the total amount of iron that can be bound by transferrin in blood</li><li><b>Transferrin Saturation:</b> Percentage of transferrin binding sites occupied by iron (calculated as Serum Iron/TIBC × 100)</li><li><b>Serum Ferritin:</b> Measures stored iron levels and reflects total body iron stores</li></ul><p>Preparation: <b>Fasting for 8-12 hours is recommended</b> for accurate serum iron measurements. Avoid iron supplements for 24 hours before testing.</p><p><b>Clinical Significance:</b> Iron studies help differentiate between various causes of anemia and evaluate iron overload conditions. Results should be interpreted together as a panel for accurate diagnosis.</p><p><b>Interpretation Guidelines:</b></p><p><b>Serum Iron:</b></p><ul><li><b>Increased levels:</b> Iron ingestion, ineffective erythropoiesis, hemochromatosis, liver disease</li><li><b>Decreased levels:</b> Iron deficiency, infection, inflammation, malignancy, menstruation. Needs to be considered with TIBC for proper interpretation</li></ul><p><b>Transferrin Saturation:</b></p><ul><li><b>Low levels (&lt;20%):</b> Iron deficiency, active erythropoiesis, infection, or inflammation</li><li><b>High levels (&gt;50%):</b> Recent dietary iron ingestion, ineffective erythropoiesis, hemochromatosis, or liver disease</li></ul><p><b>TIBC Interpretation:</b></p><ul><li><b>High TIBC:</b> Usually indicates iron deficiency, but also increased in pregnancy and with oral contraceptive use</li><li><b>Low TIBC:</b> May occur in hemochromatosis, certain types of anemia with iron accumulation, malnutrition, kidney disease causing protein loss in urine</li></ul><p><b>Ferritin Interpretation:</b></p><ul><li><b>Low ferritin:</b> Indicates depleted iron stores, early sign of iron deficiency</li><li><b>High ferritin:</b> May indicate iron overload, but also elevated in inflammation, infection, liver disease, malignancy (ferritin is an acute phase reactant)</li></ul><p><b>Common Diagnostic Patterns:</b></p><table border='1' style='border-collapse:collapse; margin:10px 0;'><tr><th>Condition</th><th>Serum Iron</th><th>TIBC</th><th>Transferrin Saturation</th><th>Ferritin</th></tr><tr><td>Iron Deficiency</td><td>Low</td><td>High</td><td>Low (&lt;20%)</td><td>Low</td></tr><tr><td>Chronic Disease</td><td>Low</td><td>Low/Normal</td><td>Low/Normal</td><td>Normal/High</td></tr><tr><td>Hemochromatosis</td><td>High</td><td>Low/Normal</td><td>High (&gt;50%)</td><td>High</td></tr><tr><td>Iron Overload</td><td>High</td><td>Normal/Low</td><td>High</td><td>High</td></tr></table><p><b>Important Notes:</b> Iron levels can vary significantly throughout the day and with dietary intake. Morning samples are preferred. Iron supplements should be discontinued before testing for accurate assessment of iron status.</p>",
        parameters: [
          {
            selected: false,
            parameterId: "IS101",
            parameterName: "Serum Iron",
            resultValue: "",
            unit: "µg/dL",
            lowerLimit: "60",
            upperLimit: "170",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "IS102",
            parameterName: "Total Iron Binding Capacity (TIBC)",
            resultValue: "",
            unit: "µg/dL",
            lowerLimit: "240",
            upperLimit: "450",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "IS103",
            parameterName: "Transferrin Saturation",
            resultValue: "",
            unit: "%",
            lowerLimit: "20",
            upperLimit: "50",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "IS104",
            parameterName: "Serum Ferritin",
            resultValue: "",
            unit: "ng/mL",
            lowerLimit: "20",
            upperLimit: "300",
            status: "Normal",
            notes: "",
          },
        ],
      },
      {
        testId: "LT99907",
        testName: "Vitamin B12 / Cyanocobalamin",
        referenceText:
          "<p><b>Reference Range:</b> 187 - 883 pg/mL</p><p><b>Low Vitamin B12 Values:</b> Low values are a sign of vitamin B12 deficiency. People with this deficiency are likely to have or develop symptoms.</p><p><b>Causes of Vitamin B12 Deficiency:</b></p><ul><li>Not enough vitamin B12 in diet (rare except with a strict vegetarian diet)</li><li>Diseases that cause malabsorption (for example, celiac disease and Crohn's disease)</li><li>Lack of intrinsic factor</li><li>Above normal heat production (for example, with hyperthyroidism)</li><li>Pregnancy</li></ul><p><b>High Vitamin B12 Values:</b> Increased vitamin B12 levels are uncommon. Usually excess vitamin B12 is removed in the urine.</p><p><b>Conditions that can increase B12 levels:</b></p><ul><li>Liver disease (such as cirrhosis or hepatitis)</li><li>Myeloproliferative disorders (for example, polycythemia vera and chronic myelocytic leukemia)</li></ul><p><b>Clinical Significance:</b> Out of 140 healthy Indian population, 91% of Vitamin B12 concentrations was at lower level: 59.00 pg/ml and upper level: 700.00 pg/ml</p><p><b>Important Note:</b> Patients on Biotin supplement may have interference in some immunoassays. With individuals taking high dose Biotin (more than 5 mg per day) supplements, at least 8-hour wait time before blood draw is recommended.</p>",
        parameters: [
          {
            selected: false,
            parameterId: "VB12101",
            parameterName: "Vitamin B12 (Cyanocobalamin)",
            resultValue: "",
            unit: "pg/mL",
            lowerLimit: "200",
            upperLimit: "900",
            status: "Normal",
            notes: "",
          },
        ],
      },
      {
        testId: "LT99908",
        testName: "Vitamin D 25-Hydroxy",
        referenceText:
          "<p>25-Hydroxy vitamin D represents the main body reservoir and transport form. This assay is useful for diagnosis of vitamin D deficiency and Hypervitaminosis D. It is also used for differential diagnosis of causes of Rickets & Osteomalacia and for monitoring Vitamin D replacement therapy.</p><p><b>Clinical Significance:</b></p><ul><li><b>Mild to moderate deficiency:</b> Associated with Osteoporosis and Secondary Hyperparathyroidism</li><li><b>Severe deficiency:</b> Causes Rickets in children and Osteomalacia in adults</li></ul><p><b>Prevalence:</b> Vitamin D deficiency is approximately >50% specially in the elderly.</p>",

        parameters: [
          {
            selected: false,
            parameterId: "VD25101",
            parameterName: "Vitamin D 25-Hydroxy (Total)",
            resultValue: "",
            unit: "ng/mL",
            lowerLimit: "30",
            upperLimit: "100",
            status: "Normal",
            notes: "",
          },
        ],
      },
      {
        testId: "LT99909",
        testName: "Thyroid Profile - Total",
        referenceText:
          "<p><b>Pregnancy Reference Range for TSH:</b></p><ul><li>1st Trimester: 0.1 - 2.5 µIU/mL</li><li>2nd Trimester: 0.2 - 3.0 µIU/mL</li><li>3rd Trimester: 0.3 - 3.0 µIU/mL</li></ul><p><b>Clinical Use:</b></p><ol><li>Diagnose Hypothyroidism & Hyperthyroidism</li><li>Monitor T4 therapy</li><li>Measure subnormal TSH levels</li></ol><p><b>TSH Interpretation:</b></p><ul><li><b>Increased TSH:</b> Primary hypothyroidism, Subclinical hypothyroidism, TSH-dependent hyperthyroidism, Thyroid hormone resistance</li><li><b>Decreased TSH:</b> Graves' disease, Autonomous thyroid hormone secretion, TSH deficiency</li></ul><p><b>Clinical Patterns:</b> Thyroid malfunction (hyper or hypo) affects T3 & T4 levels. Pituitary or hypothalamic issues also influence thyroid activity.</p><ul><li><b>Primary Hypothyroidism:</b> High TSH levels</li><li><b>Secondary/Tertiary Hypothyroidism:</b> Low TSH levels</li><li><b>Euthyroid Sick Syndrome:</b> Abnormal thyroid test results due to non-thyroidal illnesses (NTI)</li></ul><p><b>Important Note:</b> TBG levels are stable in healthy individuals but may be altered by pregnancy, estrogens, androgens, steroids, or glucocorticoids, causing inaccurate T3 & T4 readings.</p><table border='1' style='border-collapse:collapse; margin:10px 0;'><tr><th>TSH</th><th>T4</th><th>T3</th><th>Interpretation</th></tr><tr><td>High</td><td>Normal</td><td>Normal</td><td>Mild (subclinical) hypothyroidism</td></tr><tr><td>High</td><td>Low</td><td>Low or Normal</td><td>Hypothyroidism</td></tr><tr><td>Low</td><td>Normal</td><td>Normal</td><td>Mild (subclinical) hyperthyroidism</td></tr><tr><td>Low</td><td>High or Normal</td><td>High or Normal</td><td>Hyperthyroidism</td></tr><tr><td>Low</td><td>Low or Normal</td><td>Low or Normal</td><td>Nonthyroidal illness; pituitary (secondary) hypothyroidism</td></tr><tr><td>Normal</td><td>High</td><td>High</td><td>Thyroid hormone resistance syndrome</td></tr></table>",

        parameters: [
          {
            selected: false,
            parameterId: "TP101",
            parameterName: "Total T3 (Triiodothyronine)",
            resultValue: "",
            unit: "ng/dL",
            lowerLimit: "60",
            upperLimit: "200",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "TP102",
            parameterName: "Total T4 (Thyroxine)",
            resultValue: "",
            unit: "µg/dL",
            lowerLimit: "4.5",
            upperLimit: "12.0",
            status: "Normal",
            notes: "",
          },
          {
            selected: false,
            parameterId: "TP103",
            parameterName: "TSH (Thyroid Stimulating Hormone)",
            resultValue: "",
            unit: "µIU/mL",
            lowerLimit: "0.5",
            upperLimit: "4.5",
            status: "Normal",
            notes: "",
          },
        ],
      },
      {
        testId: "LT99910",
        testName: "Urine Routine and Microscopic Examination",
        referenceText:
          "<p>Urinalysis - Routine urine analysis assists in screening and diagnosis of various metabolic, urological, kidney and liver disorders.</p><p><b>Clinical Significance:</b></p><p><b>Protein:</b> Elevated proteins can be an early sign of kidney disease. Urinary protein excretion can also be temporarily elevated by strenuous exercise, orthostatic proteinuria, dehydration, urinary tract infections and acute illness with fever.</p><p><b>Glucose:</b> Uncontrolled diabetes mellitus can lead to presence of glucose in urine. Other causes include pregnancy, hormonal disturbances, liver disease and certain medications.</p><p><b>Ketones:</b> Uncontrolled diabetes mellitus can lead to presence of ketones in urine. Ketones can also be seen in starvation, frequent vomiting, pregnancy and strenuous exercise.</p><p><b>Blood:</b> Occult blood can occur in urine as intact erythrocytes or haemoglobin, which can occur in various urological, nephrological and bleeding disorders.</p><p><b>Leukocytes:</b> An increase in leukocytes is an indication of inflammation in urinary tract or kidneys. Most common cause is bacterial urinary tract infection.</p><p><b>Nitrite:</b> Many bacteria give positive results when their number is high. Nitrite concentration during infection increases with length of time the urine specimen is retained in bladder prior to collection.</p><p><b>pH:</b> The kidneys play an important role in maintaining acid base balance of the body. Conditions of the body producing acidosis/alkalosis or ingestion of certain type of food can affect the pH of urine.</p><p><b>Specific Gravity:</b> Specific gravity gives an indication of how concentrated the urine is. Increased specific gravity is seen in conditions like dehydration, glycosuria and proteinuria while decreased specific gravity is seen in excessive fluid intake, renal failure and diabetes insipidus.</p><p><b>Bilirubin:</b> In certain liver diseases such as biliary obstruction or hepatitis, bilirubin gets excreted in urine.</p><p><b>Urobilinogen:</b> Positive results are seen in liver diseases like hepatitis and cirrhosis and in cases of haemolytic anaemia.</p>",
        parameters: [
          {
            selected: false,
            parameterId: "UR101",
            parameterName: "Volume",
            resultValue: "",
            unit: "ml",
            lowerLimit: "15",
            upperLimit: "",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR102",
            parameterName: "Colour",
            resultValue: "",
            unit: "",
            lowerLimit: "Pale yellow",
            upperLimit: "Pale yellow",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR103",
            parameterName: "Transparency",
            resultValue: "",
            unit: "",
            lowerLimit: "Clear",
            upperLimit: "Clear",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR104",
            parameterName: "Deposit",
            resultValue: "",
            unit: "",
            lowerLimit: "Absent",
            upperLimit: "Absent",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR105",
            parameterName: "Reaction (pH)",
            resultValue: "",
            unit: "",
            lowerLimit: "4.5",
            upperLimit: "8.0",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR106",
            parameterName: "Specific Gravity",
            resultValue: "",
            unit: "",
            lowerLimit: "1.010",
            upperLimit: "1.030",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR107",
            parameterName: "Urine Glucose (Sugar)",
            resultValue: "",
            unit: "",
            lowerLimit: "Negative",
            upperLimit: "Negative",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR108",
            parameterName: "Urine Protein (Albumin)",
            resultValue: "",
            unit: "",
            lowerLimit: "Negative",
            upperLimit: "Negative",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR109",
            parameterName: "Urine Ketones (Acetone)",
            resultValue: "",
            unit: "",
            lowerLimit: "Negative",
            upperLimit: "Negative",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR110",
            parameterName: "Blood",
            resultValue: "",
            unit: "",
            lowerLimit: "Negative",
            upperLimit: "Negative",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR111",
            parameterName: "Leucocyte Esterase",
            resultValue: "",
            unit: "",
            lowerLimit: "Negative",
            upperLimit: "Negative",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR112",
            parameterName: "Bilirubin Urine",
            resultValue: "",
            unit: "",
            lowerLimit: "Negative",
            upperLimit: "Negative",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR113",
            parameterName: "Nitrite",
            resultValue: "",
            unit: "",
            lowerLimit: "Negative",
            upperLimit: "Negative",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR114",
            parameterName: "Urobilinogen",
            resultValue: "",
            unit: "",
            lowerLimit: "Normal",
            upperLimit: "Normal",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR115",
            parameterName: "Pus Cells (WBCs)",
            resultValue: "",
            unit: "/hpf",
            lowerLimit: "0",
            upperLimit: "5",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR116",
            parameterName: "Epithelial Cells",
            resultValue: "",
            unit: "/hpf",
            lowerLimit: "0",
            upperLimit: "4",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR117",
            parameterName: "Red Blood Cells",
            resultValue: "",
            unit: "/hpf",
            lowerLimit: "Absent",
            upperLimit: "Absent",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR118",
            parameterName: "Crystals",
            resultValue: "",
            unit: "",
            lowerLimit: "Absent",
            upperLimit: "Absent",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR119",
            parameterName: "Cast",
            resultValue: "",
            unit: "",
            lowerLimit: "Absent",
            upperLimit: "Absent",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR120",
            parameterName: "Yeast Cells",
            resultValue: "",
            unit: "",
            lowerLimit: "Absent",
            upperLimit: "Absent",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR121",
            parameterName: "Amorphous Deposits",
            resultValue: "",
            unit: "",
            lowerLimit: "Absent",
            upperLimit: "Absent",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR122",
            parameterName: "Bacteria",
            resultValue: "",
            unit: "",
            lowerLimit: "Absent",
            upperLimit: "Absent",
            status: "",
            notes: "",
          },
          {
            selected: false,
            parameterId: "UR123",
            parameterName: "Protozoa",
            resultValue: "",
            unit: "",
            lowerLimit: "Absent",
            upperLimit: "Absent",
            status: "",
            notes: "",
          },
        ],
      },
    ],
    summary: "",
  };
};
